import React, {Suspense} from 'react'

import {Loader} from '../loader'

export const withSuspenseLoader =
  <TProps = {}>(
    Component: React.ComponentType<React.PropsWithChildren<TProps>>,
    FallbackComponent?: React.ComponentType<{}>,
  ) =>
  (props: TProps) =>
    React.createElement(
      Suspense,
      {fallback: React.createElement(FallbackComponent || Loader)},
      React.createElement(Component, props),
    )
